import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, ChevronUp, LogIn, Compass, HelpCircle } from 'lucide-react';
import { FAQ_ITEMS } from '../data/demoContent';

const DemoFooter = () => {
  const navigate = useNavigate();
  const [openFaqIndex, setOpenFaqIndex] = useState(0);

  const toggleFaq = (index) => {
    setOpenFaqIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div style={{ background: '#f8fafc', paddingBottom: '30px' }}>
      {/* SECTION: FREQUENTLY ASKED QUESTIONS */}
      <section className="jp-workspace-container" id="faq" style={{ paddingTop: '50px' }}>
        <div className="erp-clean-header" style={{ marginBottom: '32px' }}>
          <div className="erp-clean-badge">
            <HelpCircle size={13} />
            <span>Questions & Answers</span>
          </div>
          <h2 className="erp-clean-title">
            Frequently Asked Questions
          </h2>
          <p className="erp-clean-desc">
            Quick answers about Prophecy Nexus access, module workflows, and integrations.
          </p>
        </div>

        <div style={{ maxWidth: '820px', margin: '0 auto' }}>
          {FAQ_ITEMS.map((item, idx) => {
            const isOpen = openFaqIndex === idx;
            return (
              <div key={idx} className="erp-faq-item-white">
                <div className="erp-faq-question-white" onClick={() => toggleFaq(idx)}>
                  <span>{item.q}</span>
                  {isOpen ? <ChevronUp size={18} color="#2563eb" /> : <ChevronDown size={18} color="#64748b" />}
                </div>
                {isOpen && <div className="erp-faq-answer-white">{item.a}</div>}
              </div>
            );
          })}
        </div>
      </section>

      {/* CALL TO ACTION BANNER (Light High-Trust Theme) */}
      <div className="erp-cta-banner-light">
        <h2>Ready to Explore Your Full ERP Workspace?</h2>
        <p>
          Log in with your enterprise credentials to access your live production dashboard, or browse open engineering opportunities.
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '14px', flexWrap: 'wrap' }}>
          <button
            type="button"
            className="erp-demo-btn-primary"
            onClick={() => navigate('/login')}
            style={{ padding: '10px 26px', fontSize: '14px' }}
          >
            <LogIn size={16} />
            <span>Sign In to Prophecy Nexus</span>
          </button>

          <button
            type="button"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: '#ffffff',
              color: '#0f172a',
              border: '1.5px solid #cbd5e1',
              padding: '10px 22px',
              borderRadius: '30px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
            onClick={() => navigate('/careers')}
          >
            <Compass size={16} color="#2563eb" />
            <span>Careers Portal</span>
          </button>
        </div>
      </div>

      {/* CLEAN FOOTER BAR */}
      <footer className="erp-footer-light">
        <div>
          © {new Date().getFullYear()} Prophecy Technologies LLC. All rights reserved. Enterprise Workforce Cloud.
        </div>

        <div style={{ display: 'flex', gap: '22px' }}>
          <span style={{ cursor: 'pointer', color: '#64748b' }} onClick={() => navigate('/careers')}>
            Careers
          </span>
          <span style={{ cursor: 'pointer', color: '#64748b' }} onClick={() => navigate('/supplier-portal')}>
            Supplier Portal
          </span>
          <span style={{ cursor: 'pointer', color: '#2563eb', fontWeight: '600' }} onClick={() => navigate('/login')}>
            ERP Login
          </span>
        </div>
      </footer>
    </div>
  );
};

export default DemoFooter;
